export default "__VITE_ASSET__CeTNdp4H__"